import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import {
  CalculatorContext,
  CalculatorContextProps,
  CalculatorFormulaType,
} from "../calculator-context";
import { CardList } from "../card-list";
import { CardAmount } from "../card-amount";
import { CardCompare } from "../card-compare";
import { CardGraph } from "../card-graph";

export const CalculatorSection = () => {
  const { t } = useTranslation("calculator");
  const [value, setValue] = useState<number>();
  const [formula, setFormula] = useState<CalculatorFormulaType>("managed");

  const props: CalculatorContextProps = {
    value,
    changeValue: (v) => setValue(+v),
    formula,
    changeFormula: (v) => setFormula(v),
  };

  return (
    <>
      <div
        className={classNames(
          "rounded-lg bg-dark px-5 py-10",
          "xxl:px-25 xxl:py-30",
        )}
      >
        <CalculatorContext.Provider value={props}>
          <div className={classNames("flex flex-col gap-5", "xl:flex-row")}>
            <div className="flex flex-col gap-5 xl:w-1/3">
              <div
                className={classNames(
                  "relative rounded-lg bg-blue-charcoal px-10 py-9",
                )}
              >
                <CardAmount />
              </div>
              <div
                className={classNames(
                  "relative rounded-lg bg-blue-charcoal px-10 py-9",
                  "flex-grow",
                )}
              >
                <CardList />
              </div>
            </div>
            <div className={classNames("flex flex-col gap-5", "xl:w-2/3")}>
              <div
                className={classNames(
                  "relative rounded-lg bg-blue-charcoal px-6 py-9",
                  "flex-grow",
                )}
              >
                <CardGraph />
              </div>

              <div
                className={classNames(
                  "relative rounded-lg bg-blue-charcoal px-10 py-9",
                )}
              >
                <CardCompare />
              </div>
            </div>
          </div>
        </CalculatorContext.Provider>

        <div className="mt-15">
          <p
            className="text-extra-small text-neutral-content"
            dangerouslySetInnerHTML={{ __html: t("footer_text") }}
          />
        </div>
      </div>
    </>
  );
};
